const mapsUrl = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

const mapsEmbedUrl = (address) =>
  `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;

export const OFFICE_ADDRESS =
  "H.NO- 7-1/681/MIG, 1st Floor, HUDA Layout, Nallagandla, Hyderabad, Telangana 502034";

export const FACTORY_ADDRESS =
  "Shed No- 3, Survey No.246 Patiganpur Village, Sivar of, Patancheruvu, Hyderabad, Telangana 502319";

export const OFFICE_MAP_URL = mapsUrl(OFFICE_ADDRESS);
export const FACTORY_MAP_URL = mapsUrl(FACTORY_ADDRESS);
export const OFFICE_MAP_EMBED_URL = mapsEmbedUrl(OFFICE_ADDRESS);

// Legal entity details as registered with GST; shown on the site for Meta Business Verification.
export const LEGAL_NAME = "Iravatham Homes Interiors & Decors Private Limited";

export const REGISTERED_ADDRESS =
  "F.No- 101, H.No- 7-1/681/MIG, Sri Sai Orchid, Lingampalli, Hyderabad, Rangareddy, Telangana 500019, India";

export const GSTIN = "36AAICI0231Q1ZD";
